import React from "react";

import { FormControl } from "lib/index";
import createCompanySettingsView from "modules/settings/createCompanySettingsView";
import { stateSelector, initializeView, updateModel, submit } from "./index";
import Hint from "./SaasSettingsHint";

const getCompanyUrl = (company) => {
  const _url = company.saas_host.split("old.").join("");

  return _url;
};

const FormContent = ({ company, errors, handleCompanyPropChange, handleCompanyTranslationPropChange }) => (
  <div>
    {!!company.saas_host && (
      <FormControl.FormGroup
        label={I18n.t("papp.settings.SaasSettingsView.saas_homepage_url")}
        help={I18n.t("papp.settings.SaasSettingsView.contact_us_if_want_to_change")}
        helpBelow
      >
        <a href={company.saas_url} target="_blank">
          {getCompanyUrl(company)}
        </a>
      </FormControl.FormGroup>
    )}

    <FormControl.InputFormGroup
      {...FormControl.addProps(`model.translations[${company.translation.uuid}].saas_name`, { errors })}
      value={company.translation.saas_name}
      onChange={handleCompanyTranslationPropChange.bind(null, company.translation, "saas_name")}
      label={I18n.humanAttributeName("company", "public_name")}
      placeholder={I18n.t("papp.common.default_value", {
        value: `${I18n.humanAttributeName("company", "name")} (${company.name})`,
      })}
    />

    <FormControl.InputFormGroup
      {...FormControl.addProps(`model.translations[${company.translation.uuid}].saas_short_description`, { errors })}
      value={company.translation.saas_short_description}
      onChange={handleCompanyTranslationPropChange.bind(null, company.translation, "saas_short_description")}
      label={I18n.humanAttributeName("company", "short_description")}
      placeholder={I18n.humanAttributeName("company", "saas_short_description_placeholder")}
    />

    <FormControl.ImageAttachmentFormGroup
      {...FormControl.addProps(`model.saas_cover_image`, { errors })}
      value={company.saas_cover_image}
      onChange={handleCompanyPropChange.bind(null, "saas_cover_image")}
      label={I18n.humanAttributeName("company", "saas_cover_image")}
    />
  </div>
);

const SaasSettingsView = createCompanySettingsView({
  stateSelector,
  actions: { initializeView, updateModel, submit },
  title: I18n.t("papp.settings.SaasSettingsView.title"),
  FormContent,
  Hint,
});

export default SaasSettingsView;



// WEBPACK FOOTER //
// ./src/modules/settings/SaasSettingsView/SaasSettingsView.jsx